import { render, staticRenderFns } from "./itemAgence.vue?vue&type=template&id=2cc3dd60&scoped=true&"
import script from "./itemAgence.vue?vue&type=script&lang=js&"
export * from "./itemAgence.vue?vue&type=script&lang=js&"
import style0 from "./itemAgence.vue?vue&type=style&index=0&id=2cc3dd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3dd60",
  null
  
)

export default component.exports